import {createSvgIcon} from '../create-svg-icon';

export const CodeOffIcon = createSvgIcon(
  <path d="m19.17 12-4.58-4.59L16 6l6 6-3.59 3.59L17 14.17 19.17 12zM1.39 4.22l4.19 4.19L2 12l6 6 1.41-1.41L4.83 12 7 9.83l12.78 12.78 1.41-1.41L2.81 2.81 1.39 4.22z" />
, 'CodeOffOutlined');
